
import { Vue, Component, Prop, PropSync, Watch } from "vue-property-decorator";
import config from "@/config";
import { pageViewUnit } from "@/config";
@Component({
  name: "TableAll",
  components: {},
})
export default class TableAll extends Vue {
  @Prop({ type: Array }) tableData!: any;
  @Prop({ type: Boolean }) loading!: any;
  @Prop({ type: Object }) format!: any;
  @Prop({ type: Number }) type!: any;
  isKunMing: any = config.isKunMing;
  pageViewUnit = pageViewUnit;
  getDepart(data: any) {
    if (data.ddepartment && data.ddepartment.departmentName) {
      return data.ddepartment.departmentName;
    }
    if (data.department && data.department.departmentName) {
      return data.department.departmentName;
    }
    return "";
  }
  toDetail(item: any) {
    switch (this.type) {
      case 0:
        {
          this.$router.push({
            path: `/pcm/policyDetail`,
            query: {
              publicyId: item.id,
            },
            /*path: `/detail/apply`,
            query: {
              projectId: item.declareItemId,
              directionId: item.id,
            },*/
          });
        }
        break;
      case 1:
        {
          this.$router.push({
            // path: `/pcm/noApply`,
            path: `/detail/apply`,
            query: {
              projectId: item.declareItemId,
              directionId: item.id,
            },
          });
        }
        break;
      case 2:
        {
          this.$router.push({
            path: `/pcm/policyDetail`,
            query: {
              publicyId: item.id,
            },
          });
        }
        break;
      case 3:
        {
          console.log("无申请兑现不跳转")
          /*this.$router.push({
            path: `/detail/text`,
            query: { textId: item.id },
          });*/
        }
        break;
      /*case 4:
        {
          this.$router.push({
            path: `/detail/publicy`,
            query: { publicyId: item.id },
          });
        }
        break;*/
      default:
        {
          return this.$message.warning("未匹配到相应政策详情");
        }
        break;
    }
  }
}
